import React from 'react';
import { ArrowLeft, Search, Menu } from 'lucide-react';

interface TopBarProps {
  titulo: string;
  subtitulo?: string;
  onVoltar: () => void;
  userName: string;
  empresaNome?: string;
  busca?: string;
  onBuscaChange?: (s: string) => void;
  buscaPlaceholder?: string;
  acoes?: React.ReactNode;
  onMenuClick?: () => void;
}

const AtlasTopBar: React.FC<TopBarProps> = ({
  titulo, subtitulo, onVoltar, userName, empresaNome,
  busca, onBuscaChange, buscaPlaceholder = 'Buscar...', acoes, onMenuClick,
}) => {
  return (
    <header className="h-16 px-3 sm:px-4 lg:px-6 flex items-center gap-2 sm:gap-4 bg-white border-b border-gray-200 sticky top-0 z-20">
      {/* Hambúrguer (mobile) */}
      <button
        onClick={onMenuClick}
        className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition flex-shrink-0"
        title="Abrir menu"
      >
        <Menu className="w-5 h-5 text-gray-600" />
      </button>

      <button
        onClick={onVoltar}
        className="hidden sm:block p-2 rounded-lg hover:bg-gray-100 transition flex-shrink-0"
        title="Voltar para a seleção de produto"
      >
        <ArrowLeft className="w-5 h-5 text-gray-600" />
      </button>

      <div className="min-w-0">
        <h2 className="font-bold text-gray-900 leading-tight truncate">{titulo}</h2>
        {subtitulo && <p className="text-xs text-gray-500 leading-tight truncate hidden sm:block">{subtitulo}</p>}
      </div>

      {onBuscaChange && (
        <div className="ml-2 sm:ml-6 flex-1 max-w-md relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            value={busca || ''}
            onChange={e => onBuscaChange(e.target.value)}
            placeholder={buscaPlaceholder}
            className="w-full pl-9 pr-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-purple-400 focus:bg-white"
          />
        </div>
      )}

      <div className="ml-auto flex items-center gap-3">
        {acoes}
        <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-full">
          <div className="w-7 h-7 rounded-full bg-purple-500 flex items-center justify-center text-white text-xs font-bold">
            {(userName || '?').charAt(0).toUpperCase()}
          </div>
          <div className="text-xs leading-tight">
            <div className="font-semibold text-gray-700">{userName}</div>
            {empresaNome && <div className="text-gray-400 text-[10px]">{empresaNome}</div>}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AtlasTopBar;
